import { DEFAULT_CATALOG_VITRINE_SETTINGS } from '../constants/catalogVitrineSettings.js';

const LEGACY_UNCONFIGURED_SETTINGS = {
  restrictToUserProductsWeb: false,
  restrictToUserProductsMobile: false,
};

/**
 * Resolve visibilidade do catálogo com retrocompatibilidade.
 *
 * Enquanto o admin não salvar pelo modal "Catálogo" (`configuredViaCatalogModal`),
 * a regra antiga dos Filtros (`settings.filterByUserProducts`) continua valendo
 * para web e mobile — clientes da master não precisam reconfigurar.
 */
export function resolveCatalogVitrineSettings(catalogSnap, legacyFilterByUserProducts) {
  const catalogData = catalogSnap?.exists?.() ? catalogSnap.data() : null;
  const configuredViaCatalogModal = !!catalogData?.configuredViaCatalogModal;

  if (
    legacyFilterByUserProducts !== undefined &&
    !configuredViaCatalogModal
  ) {
    return {
      restrictToUserProductsWeb: legacyFilterByUserProducts,
      restrictToUserProductsMobile: legacyFilterByUserProducts,
      fromLegacyFilters: true,
      configuredViaCatalogModal: false,
    };
  }

  if (!catalogSnap?.exists?.()) {
    // Nothing configured anywhere: keep the production (master/main) behavior,
    // where a missing `filterByUserProducts` meant "show everything" on BOTH
    // platforms. Applying DEFAULT_CATALOG_VITRINE_SETTINGS here silently
    // switched every existing client's mobile app to "only with access".
    return {
      ...LEGACY_UNCONFIGURED_SETTINGS,
      fromLegacyFilters: false,
      configuredViaCatalogModal: false,
    };
  }

  return {
    restrictToUserProductsWeb:
      catalogData.restrictToUserProductsWeb ??
      DEFAULT_CATALOG_VITRINE_SETTINGS.restrictToUserProductsWeb,
    restrictToUserProductsMobile:
      catalogData.restrictToUserProductsMobile ??
      DEFAULT_CATALOG_VITRINE_SETTINGS.restrictToUserProductsMobile,
    fromLegacyFilters: false,
    configuredViaCatalogModal,
  };
}

/** Campos persistidos no Firestore (sem metadados de UI). */
export function pickCatalogVitrineFields(resolved) {
  return {
    restrictToUserProductsWeb: !!resolved.restrictToUserProductsWeb,
    restrictToUserProductsMobile: !!resolved.restrictToUserProductsMobile,
  };
}
